import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
const ɵ0 = () => Date;
export class BoardApprovalEditorParameterDto {
    constructor() {
        this.clearCache = false;
    }
    getQueryString() {
        let url = `?clearCache=${this.clearCache}&processId=${this.processId}&isClosed=${this.isClosed}&addedOn=${this.addedOn.toJSON()}`;
        if (this.communityId) {
            url += `&communityId=${this.communityId}`;
        }
        if (this.boardMemberUserId) {
            url += `&boardMemberUserId=${this.boardMemberUserId}`;
        }
        return url;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], BoardApprovalEditorParameterDto.prototype, "addedOn", void 0);
export { ɵ0 };
